class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.menuButton = this.querySelector('button.header__menu-item');
    this.menuContent = this.querySelector('.mega-menu__content');

    if (!this.menuButton || !this.menuContent) return;

    this.isOpen = false;

    this.menuButton.addEventListener('click', this.toggleMenu.bind(this));
    document.addEventListener('click', this.onClickOutside.bind(this));
    document.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  toggleMenu(event) {
    event.preventDefault();
    this.isOpen ? this.closeMenu() : this.openMenu();
  }

  openMenu() {
    if (this.isOpen) return;

    this.isOpen = true;
    this.menuButton.setAttribute('aria-expanded', 'true');
    this.menuContent.style.opacity = '1';
    this.menuContent.style.visibility = 'visible';
  }

  closeMenu() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.menuButton.setAttribute('aria-expanded', 'false');
    this.menuContent.style.opacity = '0';
    this.menuContent.style.visibility = 'hidden';
  }

  onClickOutside(event) {
    if (!this.contains(event.target) && this.isOpen) {
      this.closeMenu();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (this.isOpen) {
      this.closeMenu();
      this.menuButton.focus();
    }
  }
}

customElements.define('mega-menu', MegaMenu);